import { useState } from 'react';

import { Badge, SettingsCard, SettingsCardRow, ToggleGroup, ToggleGroupItem } from 'design-system';

import type { Option } from '@/entities/user-config';
import SettingsSelectRow from '@/features/profile/components/SettingsSelectRow';

const DELIVERY_OPTIONS = [
  { label: 'In-app only', value: 'in-app' },
  { label: 'Email', value: 'email' }
];
const DIGEST_TIME_OPTIONS = [
  { label: '07:00 local', value: '07:00' },
  { label: '08:00 local', value: '08:00' }
];

type LowImportance = 'show-collapsed' | 'hide-by-default';

const isLowImportance = (value: string): value is LowImportance =>
  value === 'show-collapsed' || value === 'hide-by-default';

const MorningIntelMock = () => {
  const [delivery, setDelivery] = useState<Option>(DELIVERY_OPTIONS[0]);
  const [digestTime, setDigestTime] = useState<Option>(DIGEST_TIME_OPTIONS[0]);
  const [lowImportance, setLowImportance] = useState<LowImportance>('show-collapsed');

  return (
    <SettingsCard
      title='Morning Intel'
      action={<Badge variant='mutedOutline'>GX Crude Analyst</Badge>}
    >
      <SettingsSelectRow
        id='morning-intel-delivery'
        label='Delivery'
        options={DELIVERY_OPTIONS}
        value={delivery}
        onChange={setDelivery}
      />
      <SettingsSelectRow
        id='morning-intel-digest-time'
        label='Digest Time'
        options={DIGEST_TIME_OPTIONS}
        value={digestTime}
        onChange={setDigestTime}
      />
      <SettingsCardRow label='Low Importance'>
        <ToggleGroup
          className='grid w-full grid-cols-2'
          data-current-value={lowImportance}
          defaultValue={['show-collapsed']}
          spacing={0}
          variant='outline'
          onValueChange={values => {
            const [value] = values;
            if (value && isLowImportance(value)) {
              setLowImportance(value);
            }
          }}
        >
          <ToggleGroupItem
            className='w-full'
            value='show-collapsed'
            aria-label='Low importance: Show collapsed'
          >
            Show collapsed
          </ToggleGroupItem>
          <ToggleGroupItem
            className='w-full'
            value='hide-by-default'
            aria-label='Low importance: Hide by default'
          >
            Hide by default
          </ToggleGroupItem>
        </ToggleGroup>
      </SettingsCardRow>
    </SettingsCard>
  );
};

export default MorningIntelMock;
